var test, formal
test = process.env.NODE_ENV === 'development'
// test = true
// test = false

export {
    test,
}